import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaThumbtack } from 'react-icons/fa';
import type { Work } from '../../../api/types';
import { Icon } from '../../../components/Icon';
import { parseWorkTitle } from '../utils/parseWorkTitle';
import './WorkCard.css';

interface WorkCardProps {
    work: Work;
    index: number;
}

export const WorkCard: React.FC<WorkCardProps> = ({ work, index }) => {
    const year = new Date(work.date).getFullYear();

    const { mainTitle, subtitle } = parseWorkTitle(work.title);

    return (
        <Link to={`/works/${work.slug}`} className="work-card-link">
            <motion.div
                className="work-card"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{
                    duration: 0.5,
                    delay: index * 0.1
                }}
            >
                {work.imageUrls && work.imageUrls.length > 0 && (
                    <div className="work-card-image-wrapper">
                        <img
                            src={work.imageUrls[0]}
                            alt={work.title}
                            className="work-card-image"
                        />
                        {typeof work.pinnedOrder === 'number' && (
                            <div className="work-card-pin" aria-label="Pinned">
                                <Icon icon={FaThumbtack} />
                            </div>
                        )}
                    </div>
                )}
                <div className="work-card-content">
                    <div className="work-card-info">
                        <div className="work-card-year">{year}</div>
                        <div className="work-card-title-wrapper">
                            <h3 className="work-card-title">
                                {mainTitle.split('').map((char, i) => {
                                    // Check if character is Japanese (Hiragana, Katakana, or Kanji)
                                    const isJapanese = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\u4e00-\u9faf\u3400-\u4dbf]/.test(char);
                                    return isJapanese ? (
                                        <span key={i} className="japanese-text">{char}</span>
                                    ) : (
                                        <span key={i}>{char}</span>
                                    );
                                })}
                            </h3>
                            {subtitle && <span className="work-card-subtitle">{subtitle}</span>}
                        </div>
                    </div>
                    <div className="work-card-category">
                        {work.tags[0]}
                    </div>
                </div>
            </motion.div>
        </Link>
    );
};